<sd-modal>
  <div class="wrapper">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title"><h3>Вы действительно хотите удалить аккаунт?</h3></div>
    </div>
    <div class="cx-dialog-body modal-body">
      <div class="row justify-content-center">
        <div class="button-wrapper">
          <button sdButton type="outlined" size="l" (click)="onDelete()">Удалить аккаунт</button>
        </div>
      </div>
      Удалив аккаунт, вы&nbsp;потеряете все данные в&nbsp;этой учетной записи, такие как история заказов, сохраненные
      карты, добавленные компании, сопроводительные документы, товары, добавленные в&nbsp;избранное и&nbsp;сравнение.
    </div>
  </div>
</sd-modal>
